import { AvailabilityDay } from '../../interfaces/AvailabilityDay';
import { APICore, API_URL } from './apiCore';

const api = new APICore();

function generateEmptyData(): AvailabilityDay[] {
    const mockData: AvailabilityDay[] = [];
    const today = new Date();
    for (let i = 0; i < 31; i++) {
        const currentDate = new Date(today);
        currentDate.setDate(today.getDate() + i);

        const scheduledHours = 0;
        const availableHours = 0;
        const availabilityPercentage = 0;

        const availabilityDay: AvailabilityDay = {
            _id: `${i}`,
            day: currentDate,
            scheduledHours: scheduledHours,
            availableHours: availableHours,
            totalHours: availableHours + scheduledHours,
            availabilityPercentage: availabilityPercentage,
        };

        mockData.push(availabilityDay);
    }
    return mockData;
}

const getAvailability = () => {
    return api.get(`${API_URL}/meeting-availability`);
};

const updateAvailability = (day: AvailabilityDay) => {
    const { _id, manualTotalHours } = day;
    return api.update(`${API_URL}/meeting-availability/${_id}`, {
        manualTotalHours,
    });
};

const resetAvailability = (_id: string) => {
    return api.delete(`${API_URL}/meeting-availability/${_id}`);
};

const getOnboardingStatusTrackers = (params: { onboardingId?: string; clientId?: string }) => {
    const url = `${API_URL}/onboarding/status-trackers`;
    return api.get(url, params);
};

export { getAvailability, updateAvailability, resetAvailability, generateEmptyData, getOnboardingStatusTrackers };
